import { type RouteRecordRaw } from 'vue-router'
import MenuDesignPage from '../../pages/MenuDesignPage.vue'
import { api } from '../../services/api' // axios instance
import {ROUTES, API_ENDPOINTS} from '@myorg/type-lib'

// 實作 Lib 定義的 API 介面
// export const changePasswordApiImpl = {
//   changePassword: async (payload: any) => {
//     // 這裡對接您實際的後端 API 端點
//     const res = await api().post('/api/auth/change-password', {
//       account: payload.account,
//       password: payload.password
//     })
//     return res.data
//   }
// }

export const MenuDesignRoute: RouteRecordRaw = {
    path: ROUTES.MENU.PATH,
    name: ROUTES.MENU.NAME,
    component: MenuDesignPage,
//   props: () => ({
//     changePasswordApi: changePasswordApiImpl
//   })
}